import {
    PlusOutlined,
} from "@ant-design/icons";
import {
    Button,
    Col,
    ConfigProvider,
    DatePicker,
    Row,
    Select,
    Space,
    Spin,
    Switch,
    Table,
    Tag,
} from "antd";
import { Footer } from "antd/es/layout/layout";
import frFR from "antd/locale/fr_FR";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { rightsService } from "../../../services/rightsService";
import axiosInstance from "../../../variables/api/axiosInstance";
import { LOGGED_USER } from "../../../variables/constants";
import {
    frenchDate,
    frenchDateSimple,
} from "../../../variables/functions";
import { displayNumbers } from "../../../variables/numbersFunctions";
import { StatCard } from "../../../components/statistics/StatCard";
import { COLORS } from "../../../components/ui/colors";

const { RangePicker } = DatePicker;

const dateFormat = "DD/MM/YYYY";

const Propositions = () => {
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [data, setData] = useState([]);
    const [selecting, setSelecting] = useState(false);
    const [loadingContrats, setLoadingContrats] = useState(true);
    const [loading, setLoading] = useState(false);
    const [membres, setMembres] = useState([]);
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [banques, setBanques] = useState([]);
    const [count, setCount] = useState("");

    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedCompagnies, setSelectedCompagnies] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, showSizeChanger: true });

    const columns = [
        {
            title: "Numero de devis",
            dataIndex: "numeroPolice",
            key: "1",
        },
        {
            title: "Souscripteur",
            dataIndex: "souscripteur",
            key: "2",
        },
        {
            title: "Organisme",
            dataIndex: "organisme",
            key: "3",
        },
        {
            title: "Date Effet",
            dataIndex: "dateEffet",
            key: "4",
        },
        {
            title: "Date Echeance",
            dataIndex: "dateEcheance",
            key: "5",
        },
        {
            title: "Statut reg.",
            dataIndex: "regle",
            key: "regle",
            render: (_, record) => (
                <>
                    {record.regle === "REGLE" ? (
                        <Tag color="success" key={_}>
                            REGLE
                        </Tag>
                    ) : (
                        <Tag color="blue" key={_}>
                            NON REGLE
                        </Tag>
                    )}
                </>
            ),
            filters: [
                {
                    text: "REGLE",
                    value: "REGLE",
                },
                {
                    text: "NON REGLE",
                    value: "NON REGLE",
                },
            ],
            filteredValue: filteredInfo.regle || null,
            onFilter: (value, record) => record.regle === value,
            sorter: (a, b) => a.regle.length - b.regle.length,
            sortOrder: sortedInfo.columnKey === "regle" ? sortedInfo.order : null,
            ellipsis: true,
        },
        {
            title: "Prime nette",
            dataIndex: "primeNette",
            key: "primeNette",
        },
        {
            title: "Accessoires",
            dataIndex: "accessoires",
            key: "accessoires",
        },
        {
            title: "Taxes",
            dataIndex: "taxes",
            key: "taxes",
        },
        {
            title: "Prime TTC",
            dataIndex: "primeTotale",
            key: "primeTotale",
        },
        Table.EXPAND_COLUMN,
        {
            title: "Actions",
            dataIndex: "actions",
            key: "7",
            render: (_, record) => (
                <>
                    <button
                        type="button"
                        class="btn btn-primary btn-icon rounded-pill"
                        onClick={() => navigate(`/details-contrat/${record.codeId}`)}
                    >
                        <i class="bx bx-dots-vertical-rounded"></i>
                    </button>
                </>
            ),
        },
    ];

    const navigate = useNavigate();

    const handleChange = (pagination, filters, sorter) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
        setPagination(pagination);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const handleDateChange = (dates, dateStrings) => {
        const [sDate, eDate] = dateStrings;
        console.log(dateStrings);
        const [startDay, startMonth, startYear] = sDate.split("/");
        const [endDay, endMonth, endYear] = eDate.split("/");
        const startDate = `${startYear}-${startMonth}-${startDay}`;
        const endDate = `${endYear}-${endMonth}-${endDay}`;
        console.table([startDate, endDate]);
        setSelectedDate([startDate, endDate]);
        setFilteredInfo({
            ...filteredInfo,
            startDate,
            endDate,
        });
        fetchData({
            pagination,
            filters: {
                ...filteredInfo,
                startDate,
                endDate,
            },
        });
    };

    const fetchData = async (params = {}) => {
        setLoadingContrats(true);
        try {
            const response = await axiosInstance.get("/api/contrat/proposition", {
                params: {
                    page: params.pagination.current - 1,
                    size: params.pagination.pageSize,
                    ...params.filters,
                    compagnie: params.filters?.compagnie?.join(','),  // join the compagnies with `&compagnie=`
                },
            });
            const { content, totalElements } = response.data;
            // console.log("Total element; ", totalElements);
            console.log(" element; ", content);
            let ctrs = [];
            content.forEach((contrat, key) => {
                ctrs.push({
                    key: contrat.codeId,
                    codeId: contrat.codeId,
                    id: key,
                    numeroPolice: contrat.numeroPoliceM
                        ? contrat.numeroPoliceM
                        : contrat.numeroPoliceP,
                    souscripteur: contrat?.prenom
                        ? `${contrat?.prenom} ${contrat?.nom}`
                        : `${contrat?.nom}`,
                    organisme: contrat?.raisonSociale,
                    dateEffet: contrat?.dateEffet
                        ? `${frenchDate(contrat?.dateEffet)}`
                        : "",
                    dateEcheance: contrat?.dateEcheance
                        ? `${frenchDateSimple(contrat?.dateEcheance)} `
                        : "",
                    regle: contrat.reglements
                        ? contrat.reglements
                            ? "REGLE"
                            : "NON REGLE"
                        : "NON REGLE",
                    primeTotale: new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(contrat?.primeTotale),
                    taxes: new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(contrat?.primeTotale * 0.06 / 1.06),
                    primeNette: new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(contrat?.primeNette),
                    accessoires: new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(contrat?.accessoires),
                    data: contrat,
                });
            });
            setData(ctrs);
            setPagination({
                ...params.pagination,
                total: totalElements,
            });
            setTotal(totalElements);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setLoadingContrats(false);
        }
    };

    useEffect(() => {
        // fetchContracts(currentPage, pageSize, "", selectedDate, selectedCompagnie);
        if (selectedDate || selectedCompagnies) {
            if (selectedDate) {
                const startDate = selectedDate[0];
                const endDate = selectedDate[1];
                fetchData({
                    pagination,
                    filters: {
                        ...filteredInfo,
                        startDate,
                        endDate,
                        compagnie: selectedCompagnies
                    },
                });
            } else {
                fetchData({
                    pagination,
                    filters: {
                        ...filteredInfo,
                        compagnie: selectedCompagnies
                    },
                });
            }

        } else {
            fetchData({
                pagination,
                filteredInfo,
            });
        }

        axiosInstance
            .get(`/api/parametre/type/BANQUE`)
            .then((res) => {
                setBanques(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/organisme/assurance`)
            .then((res) => {
                let membs = [];
                res.data.forEach((memb, index) => {
                    membs.push({
                        key: index,
                        text: memb.raisonSociale,
                        value: memb.code,
                        data: memb,
                    });
                });
                membs.push({
                    key: "DTRF",
                    text: "DTRF",
                    value: "DTRF",
                });
                membs.push({
                    key: "DTRF-Lome",
                    text: "DTRF-LOME",
                    value: "LOME",
                });
                membs.push({
                    key: "DTRF-Kpalime",
                    text: "DTRF-KPALIME",
                    value: "KPALIME",
                });
                membs.push({
                    key: "DTRF-Atakpame",
                    text: "DTRF-ATAKPAME",
                    value: "ATAKPAME",
                });
                membs.push({
                    key: "DTRF-Sokode",
                    text: "DTRF-SOKODE",
                    value: "SOKODE",
                });
                membs.push({
                    key: "DTRF-Kara",
                    text: "DTRF-KARA",
                    value: "KARA",
                });
                membs.push({
                    key: "DTRF-Dapaong",
                    text: "DTRF-DAPAONG",
                    value: "DAPAONG",
                });
                membs.push({
                    key: "STCA",
                    text: "STCA",
                    value: "STCA",
                });
                setMembres(membs);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/contrat/count`)
            .then((res) => {
                console.log("Count: ", res.data);
                setCount(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [loading, currentPage, pageSize, selectedDate]);

    const filteringOnCompanies = (companies) => {
        setSelectedCompagnies(companies);
        console.log(companies);
        setFilteredInfo({
            ...filteredInfo,
            compagnie: companies
        });
        fetchData({
            pagination,
            filters: {
                ...filteredInfo,
                compagnie: companies
            },
        });
    };

    const onSelectChange = (newSelectedRowKeys, rows) => {
        // console.log("selectedRowKeys changed: ", newSelectedRowKeys);
        // console.log("SelectedRows", rows);
        setSelectedRows(rows);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };


    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar currentMenu={"PRODUCTION"} />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <Row style={{ marginBottom: "15px", justifyContent: "space-between" }}>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats"
                                        subtitle="Total contrats"
                                        value={displayNumbers(total || 0)}
                                        icon="bx bx-file"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats validés"
                                        subtitle="Nbre total actifs / Nbre total validés"
                                        value={`${count?.activeCount ? displayNumbers(count?.activeCount) : 0} / ${count?.valideCount ? displayNumbers(count?.valideCount) : 0}`}
                                        icon="bx bx-check-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats annulés"
                                        subtitle="Contrats annulés"
                                        value={displayNumbers(count?.annuleCount || 0)}
                                        icon="bx bx-x-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats en attente"
                                        subtitle="Contrats en Proposition"
                                        value={displayNumbers(count?.enPropositionCount || 0)}
                                        icon="bx bx-time-five"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                            </Row>
                            {/* <!-- Users List Table --> */}
                            <div class="row">
                                <div class="col-sm-4">
                                    {rightsService("HCO022") ||
                                        rightsService("HCO005") ||
                                        rightsService("HCO019") ? (
                                        <Button
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            style={{ marginBottom: 16, backgroundColor: COLORS.secondary }}
                                            onClick={() => navigate("/ajouter-contrat-new")}
                                        >
                                            Nouveau contrat
                                        </Button>
                                    ) : null}
                                </div>
                            </div>

                            <div class="card">
                                <div class="container">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-4">
                                                    <Space align="center" style={{ marginBottom: 16 }}>
                                                        Mode sélection:{" "}
                                                        <Switch
                                                            checked={selecting}
                                                            onChange={setSelecting}
                                                        />
                                                    </Space>
                                                </div>
                                                <div class="col-4">
                                                    <RangePicker
                                                        format={dateFormat}
                                                        onChange={handleDateChange}
                                                        placeholder="Filtre par date"
                                                    />
                                                </div>
                                                {LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL" && (LOGGED_USER?.agence?.typeAgence === "SIEGE" || LOGGED_USER?.agence === null) ?
                                                    <div class="col-4">
                                                        <Select
                                                            mode="multiple"
                                                            placeholder="Filtre par compagnie"
                                                            onChange={filteringOnCompanies}
                                                            options={membres.map((memb) => (
                                                                {
                                                                    label: memb.text,
                                                                    value: memb.value,
                                                                    key: memb.value
                                                                }
                                                            ))}
                                                            style={{ width: "80%" }}
                                                        />
                                                    </div> : null}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ConfigProvider locale={frFR}>
                                    <Spin spinning={loadingContrats}>
                                        <Table
                                            rowSelection={selecting ? rowSelection : null}
                                            columns={columns}
                                            rowKey="codeId"
                                            dataSource={data}
                                            onChange={handleChange}
                                            pagination={pagination}
                                        />
                                    </Spin>
                                </ConfigProvider>
                            </div>
                        </div>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div class="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            {/* <!-- Overlay --> */}
            <div class="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div class="drag-target"></div>
        </div>
    );
};

export default Propositions;